import styles from "./index.module.css";
import React, { forwardRef, PropsWithChildren, ReactNode } from "react";
import { AsideHint } from "@/components/AppShell/AsideHint";
import { Space } from "@mantine/core";

interface MobileViewProps extends PropsWithChildren {
  backButton: ReactNode | undefined;
  dropdown: ReactNode | undefined;
  size: "lg" | "xl";
  hintMessage: React.ReactElement | string;
  isThankYouPage?: boolean;
}

export const MobileView = forwardRef<HTMLDivElement, MobileViewProps>(
  ({ backButton, dropdown, size, hintMessage, isThankYouPage = false, children }, ref) => {
    return (
      <>
        {backButton ?? dropdown ? (
          <>
            <div className={styles.mobileHeader} data-size={size}>
              <div className={styles.mobileButtonGroup}>
                {backButton} {dropdown}
              </div>
              <AsideHint hintMessage={hintMessage} ref={ref} />
            </div>
          </>
        ) : (
          <Space h="md" />
        )}
        <div className={styles.content}>
          <div className={styles.paper} data-size={size} data-thank-you={isThankYouPage}>
            {children}
          </div>
        </div>
      </>
    );
  }
);
